import React from "react";

export default function FiberMorphologySummary({ fiberMorphology = [] }) {
    if (!fiberMorphology || !fiberMorphology.length) {
        return <span className="text-muted small italic p-2">No morphology data</span>;
    }

    // Group by category for nicer display
    const grouped = fiberMorphology.reduce((acc, item) => {
        if (!acc[item.category]) acc[item.category] = [];
        acc[item.category].push({ label: item.label, abbreviation: item.abbreviation });
        return acc;
    }, {});

    return (
        <div className="morphology-summary-container p-1" style={{ minWidth: '200px' }}>
            <div className="fw-bold text-primary border-bottom mb-2 pb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Fiber Morphology
            </div>
            <div className="d-flex flex-column gap-3">
                {Object.entries(grouped).map(([category, items]) => (
                    <div key={category}>
                        <div className="text-secondary fw-bold mb-1" style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}>{category}</div>
                        <div className="d-flex flex-column gap-1">
                            {items.map((it, idx) => (
                                <div key={idx} className="badge bg-light text-dark border fw-medium text-start py-2 px-3" style={{ fontSize: '0.75rem', width: '100%' }}>
                                    {it.label}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
